import { getLocalPersistantData } from "../../sagas/persistantDataSaga";
import { b64DecodeUnicode }       from "../../utils/dataUtils";
import { getQualifiedInsINSi }    from "../certifiedIdentity";

export const generateDownloadInsFilesUrl = (cpxInternalId, ins, files) => {
  const json = JSON.stringify({
    psId: cpxInternalId, ins, files, version: 1
  });
  return `data:text/plain,${encodeURIComponent(json)}`;
};

export const generateDownloadCardFilesUrl = (cpxInternalId, files) => {
  const json = JSON.stringify({
    psId: cpxInternalId, files, version: 1
  });
  return `data:text/plain,${encodeURIComponent(json)}`;
};

export const extractPersistantDataFromSectionAndDecode = ({ s_persistantData64 = "" }) => (
  s_persistantData64 !== "" ? JSON.parse(b64DecodeUnicode(s_persistantData64)) : undefined
);

export const getInsFilesFromPersistedData = (persistedData, cpxId, ins) => {
  const {
          efficience: {
            submittedDocuments: {
              [cpxId]: {
                [ins]: files = {}
              } = {}
            } = {}
          } = {}
        } = persistedData;
  return files;
};

export const getCardFilesFromPersistedData = (persistedData = {}, cpxId) => {
  const {
          efficience: {
            submittedDocuments: {
              [cpxId]: files
            } = {}
          } = {}
        } = persistedData;
  return files;
};

export const getInsQualification = (state, identity) => {
  const persistantData = getLocalPersistantData(state);
  
  const ins = getQualifiedInsINSi(identity);
  
  const
    {
      efficience: {
        insQualifications: {
          [ins]: qualification
        } = {}
      } = {}
    } = (persistantData || {});
  
  return qualification;
};
